import { ClaimReportingChronicleTypeSchema, } from '../../claimReportingCompiler.js';
export var ClaimReportingTimelineLabel;
(function (ClaimReportingTimelineLabel) {
    ClaimReportingTimelineLabel["carrierApproved"] = "carrierApproved";
    ClaimReportingTimelineLabel["inspectionCreation"] = "inspectionCreation";
    ClaimReportingTimelineLabel["estimateUploaded"] = "estimateUploaded";
    ClaimReportingTimelineLabel["latestEstimateUploaded"] = "latestEstimateUploaded";
})(ClaimReportingTimelineLabel || (ClaimReportingTimelineLabel = {}));
const defaultLabelMap = Object.fromEntries(ClaimReportingChronicleTypeSchema.options.map((key) => [key, key]));
export const claimReportingChronicleLabelMap = {
    ...defaultLabelMap,
    carrierApprovedEstimate: ClaimReportingTimelineLabel.carrierApproved,
    fieldAdjusterEstimateUploaded: ClaimReportingTimelineLabel.estimateUploaded,
    inspectionScheduled: ClaimReportingTimelineLabel.inspectionCreation,
    latestEstimateUploaded: ClaimReportingTimelineLabel.latestEstimateUploaded,
};
